"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("./myPointTask"), exports);
(0, tslib_1.__exportStar)(require("./submitPointTask"), exports);
(0, tslib_1.__exportStar)(require("./myPointDetail"), exports);
(0, tslib_1.__exportStar)(require("./myPointDetailNew"), exports);
(0, tslib_1.__exportStar)(require("./exchange"), exports);
(0, tslib_1.__exportStar)(require("./mall"), exports);
(0, tslib_1.__exportStar)(require("./followWechat"), exports);
(0, tslib_1.__exportStar)(require("./updateInviteTime"), exports);
(0, tslib_1.__exportStar)(require("./politeInvitationInit"), exports);
(0, tslib_1.__exportStar)(require("./lotteryInit"), exports);
(0, tslib_1.__exportStar)(require("./runLottery"), exports);
(0, tslib_1.__exportStar)(require("./rankPoint"), exports);
(0, tslib_1.__exportStar)(require("./productdetail"), exports);
(0, tslib_1.__exportStar)(require("./productexchangeinit"), exports);
//# sourceMappingURL=index.js.map